import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up crm-form-wrapper crm-form-new" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "qc-item-wrap crm-item-wrap crm-item-wrap-bare" }
const _hoisted_5 = { class: "quick-add-heading" }
const _hoisted_6 = {
  key: 0,
  class: "quick-add-note"
}
const _hoisted_7 = {
  key: 1,
  class: "quick-add-note"
}
const _hoisted_8 = { class: "quick-add-row" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["label"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "quick-add-row" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "quick-add-row" }
const _hoisted_16 = {
  key: 0,
  class: "due-date-nudge"
}
const _hoisted_17 = { class: "item-private" }
const _hoisted_18 = {
  key: 0,
  class: "item-private-warn"
}
const _hoisted_19 = { class: "board-tip-tap" }
const _hoisted_20 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tip_tap = _resolveComponent("tip-tap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.heading), 1),
          (!_ctx.loaded)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Loading your meetings…"))
            : (!_ctx.meetings.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "You don't have any meetings to add to yet."))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_8, [
                    (!_ctx.fixedMeeting)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", {
                            class: "crm-item-label",
                            style: {"margin-top":"0"}
                          }, "Meeting", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.meetingID) = $event)),
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.meetingChange()))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meetingGroups, (g) => {
                              return (_openBlock(), _createElementBlock("optgroup", {
                                key: g.label,
                                label: g.label
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.meetings, (m) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: m.ID,
                                    value: m.ID
                                  }, _toDisplayString(m.Name), 9, _hoisted_11))
                                }), 128))
                              ], 8, _hoisted_10))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.meetingID]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("div", {
                        class: "crm-item-label",
                        style: {"margin-top":"0"}
                      }, "Column", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.column) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (c) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: c.name,
                            value: c.name
                          }, _toDisplayString(c.name), 9, _hoisted_12))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.column]
                      ])
                    ])
                  ]),
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "crm-item-label" }, "Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    style: {"margin":"0"},
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Name) = $event)),
                    ref: "nameInput",
                    onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.submit()), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.form.Name]
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "crm-item-label" }, "Priority", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.Priority) = $event))
                      }, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("option", { value: null }, "No Priority", -1),
                        _createElementVNode("option", { value: "high" }, "High", -1),
                        _createElementVNode("option", { value: "med" }, "Medium", -1),
                        _createElementVNode("option", { value: "low" }, "Low", -1)
                      ]))], 512), [
                        [_vModelSelect, _ctx.form.Priority]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "crm-item-label" }, "Assigned To", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.AssigneeEmployeeID) = $event))
                      }, [
                        _cache[16] || (_cache[16] = _createElementVNode("option", { value: null }, "Unassigned", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assigneeOptions, (emp) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: emp.ID,
                            value: emp.ID
                          }, _toDisplayString(emp.Name), 9, _hoisted_14))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.form.AssigneeEmployeeID]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "crm-item-label" }, "Due Date", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.DueDate) = $event)),
                        class: _normalizeClass(_ctx.dueDateNudge ? 'due-date-missing' : '')
                      }, null, 2), [
                        [_vModelText, _ctx.form.DueDate]
                      ]),
                      (_ctx.dueDateNudge)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, "No due date yet. We recommend setting one."))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("div", null, null, -1))
                  ]),
                  _createElementVNode("label", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.Private) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.Private]
                    ]),
                    _cache[20] || (_cache[20] = _createStaticVNode("<span class=\"item-private-track\" data-v-13ea3163><span class=\"item-private-knob\" data-v-13ea3163></span></span><span class=\"item-private-text\" data-v-13ea3163><span class=\"item-private-title\" data-v-13ea3163>Only visible to me</span><span class=\"item-hint\" data-v-13ea3163>Other attendees won&#39;t see this card on the board or in the meeting history.</span></span>", 2))
                  ]),
                  (_ctx.form.Private && _ctx.form.AssigneeEmployeeID && _ctx.form.AssigneeEmployeeID != _ctx.$store.state.user.employeeID)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.assigneeName || 'The assignee') + " won't see this card while it's only visible to you. ", 1))
                    : _createCommentVNode("", true),
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "crm-item-label" }, "Description", -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_tip_tap, {
                      modelValue: _ctx.form.Description,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.Description) = $event)),
                      "hide-h3": true,
                      "hide-h4": true,
                      "hide-table": true
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("input", {
                    style: {"margin-top":"20px"},
                    class: _normalizeClass(_ctx.saving ? 'disable-button' : ''),
                    type: "submit",
                    value: _ctx.dueDateNudge ? 'Submit Without Due Date' : 'Submit',
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.submit()))
                  }, null, 10, _hoisted_20)
                ], 64))
        ])
      ])
    ])
  ]))
}